import React from 'react';

import { Container } from './styledComponents';

export const DatePickerInputIcon = (date) => (
  <Container>
    <img
      alt="arrow"
      src={
        !!date
          ? '/images/inpulse/calendar-black-small.svg'
          : '/images/inpulse/calendar-dmgrey-small.svg'
      }
    />
  </Container>
);
